module.exports = __webpack_public_path__ + "static/media/envelope_gray.df116cbc.svg";